// extracted by mini-css-extract-plugin
module.exports = {"Separator":"styles_Separator__MdVjh","line":"styles_line__1WUG9"};